export enum AssetRenderStyle {
    tile = "TILE",
    list = "LIST",
}
